// extracted by mini-css-extract-plugin
export var testimonialcontainer = "testimonial-module--testimonialcontainer--LRsQp";
export var content = "testimonial-module--content--CNhGM";
export var secondaryHeading = "testimonial-module--secondaryHeading--nK5d3";
export var testimonial = "testimonial-module--testimonial--9UfCt";
export var quote = "testimonial-module--quote--qJbls";
export var author = "testimonial-module--author--goebN";
export var avatar = "testimonial-module--avatar--RdtMp";
export var authorInfo = "testimonial-module--authorInfo--qX9ja";